// All comments in English.
import React, { ReactNode } from "react";

export default function SectionCard({ children }: { children: ReactNode }) {
  return <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">{children}</div>;
}
